import { Resources } from 'constants/resources';

import { useQuery } from '@tanstack/react-query';
import { getRefundChargebackReport } from 'config/requests/refundChargebackReport';
import { RefundChargebackReportListFilterValues } from 'pages/Finance/RefundChargebackReport/RefundChargebackReportFilter/RefundChargebackReportFilter';
import { RefundChargebackReport } from 'types/embedded/refundChargebackReport';

type UseGetRefundChargebackReportReturnValue = {
  report?: RefundChargebackReport;
  total: number;
  isLoading: boolean;
};

export function useGetRefundChargebackReport(
  filters: RefundChargebackReportListFilterValues,
): UseGetRefundChargebackReportReturnValue {
  const { data: report, isLoading } = useQuery<RefundChargebackReport>({
    queryKey: [
      Resources.CumulativeReport,
      filters.currency,
      filters.gateway,
      filters.status,
      filters.merchant,
      filters.provider,
      filters.appliedDate,
      filters.updatedDate,
      filters.createdAt,
      filters.updatedAt,
      filters.summary,
      filters.conversionCurrency,
      filters.impactToBalance,
      filters.company,
      filters.updatedDate,
      filters.id,
      filters.merchantReference,
      filters.providerReferenceId,
      filters.transaction,
      filters.timezone,
      filters.merchantAccount,
    ],
    queryFn: () => getRefundChargebackReport(filters),
    enabled: Object.keys(filters).length > 0,
  });
  const total = report?.orders?.length || 0;

  return { report, total, isLoading };
}
